import axios from "axios";
import appconst from "./appconst";
import Vue from "vue";
import moment from "moment";
import qs from "qs";
import _ from "lodash";
var JSONbigNative = require("json-bigint")({ useNativeBigInt: false });
const ajax = axios.create({
  baseURL: appconst.remoteServiceBaseUrl,
  timeout: 720000,
  paramsSerializer: function(params) {
    return qs.stringify(params, {
      encode: false,
    });
  },
  transformResponse: [
    (data) => {
      if (typeof data === "string") {
        try {
          data = JSONbigNative.parse(data);
        } catch (e) {
          console.log(e);
          /* Ignore */
        } // Added this Ignore as it's the same in the Axios
      }
      return data;
    },
  ],
});

ajax.interceptors.request.use(
  function(config) {
    if (!!window.abp.auth.getToken()) {
      config.headers.common["Authorization"] =
        "Bearer " + window.abp.auth.getToken();
    }
    config.headers.common[
      ".AspNetCore.Culture"
    ] = window.abp.utils.getCookieValue("Abp.Localization.CultureName");
    config.headers.common[
      "Abp.TenantId"
    ] = window.abp.multiTenancy.getTenantIdCookie();

    config.paramsSerializer = (params) =>
      qs.stringify(params, {
        serializeDate: (date: Date) =>
          moment(date).format("YYYY-MM-DD HH:mm:ss"),
      });
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);
let vm = new Vue({});
ajax.interceptors.response.use(
  (respon) => {
    return respon;
  },
  (error) => {
    console.log("error", error);

    if (
      !!error.response &&
      !!error.response.status &&
      error.response.status === 401
    ) {
      window.location.href = appconst.appBaseUrl;
    } else {
      // return response
      if (
        !!error.response &&
        !!error.response.data.error &&
        !!error.response.data.error.message &&
        !!error.response.data.error.details &&
        !!error.response.data.error.validationErrors
      ) {
        vm.$Notice.error({
          title: window.abp.localization.localize(
            "ErrorTitle",
            appconst.localization.defaultLocalizationSourceName
          ),
          desc: window.abp.localization.localize(
            error.response.data.error.validationErrors[0].message,
            appconst.localization.defaultLocalizationSourceName
          ),
        });
      } else if (
        !!error.response &&
        !!error.response.data.error &&
        !!error.response.data.error.message
      ) {
        vm.$Notice.error({
          title: window.abp.localization.localize(
            "ErrorTitle",
            appconst.localization.defaultLocalizationSourceName
          ),
          desc: window.abp.localization.localize(
            error.response.data.error.message,
            appconst.localization.defaultLocalizationSourceName
          ),
        });
      } else if (!error.response) {
        vm.$Notice.error({
          title: window.abp.localization.localize(
            "ErrorTitle",
            appconst.localization.defaultLocalizationSourceName
          ),
          desc: window.abp.localization.localize(
            "UnknownError",
            appconst.localization.defaultLocalizationSourceName
          ),
        });
      }
      return Promise.reject(error);
    }
  }
);
export default ajax;
